export var UserPermissionKeys;
(function (UserPermissionKeys) {
    UserPermissionKeys["Interact"] = "INTERACT";
    UserPermissionKeys["ViewEmailAddress"] = "VIEW_EMAIL_ADDRESS";
    UserPermissionKeys["ViewMessages"] = "VIEW_MESSAGES";
    UserPermissionKeys["SaveExcerpts"] = "SAVE_EXCERPTS";
    UserPermissionKeys["ManageCodeBook"] = "MANAGE_CODE_BOOK";
    UserPermissionKeys["Reports"] = "REPORTS";
    UserPermissionKeys["Transcripts"] = "TRANSCRIPTS";
    UserPermissionKeys["Leaderboard"] = "LEADERBOARD";
    UserPermissionKeys["ActionLog"] = "ACTION_LOG";
    UserPermissionKeys["Backroom"] = "BACKROOM";
    UserPermissionKeys["ViewExcerpts"] = "VIEW_EXCERPTS";
    UserPermissionKeys["HideUnreviewed"] = "HIDE_UNREVIEWED";
    UserPermissionKeys["ViewAiAnalysis"] = "VIEW_AI_ANALYSIS";
})(UserPermissionKeys || (UserPermissionKeys = {}));
